module.exports = __webpack_public_path__ + "static/media/communityDesktop.44041a6f.png";